import $, { extend } from 'jquery';
import 'react-bootstrap/dropdown';
import Popper from 'popper.js';
//import {Popper} from '@popperjs/core';
import React from 'react';

import "jquery-ui-bundle/jquery-ui";
import "jquery-ui-bundle/jquery-ui.css";

import 'react-bootstrap/modal';

import 'react-bootstrap/tooltip';

import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker,
  btnSetColor_CBack} from '../function_lib/common_lib';

import {CompGetAcademicYear} from '../components/comp_auto_complete';
import {CompGetCurriculum,CompGetAcademicProgram} from '../components/comp_auto_complete';
import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';


import defaultPic from '../assets/images/9.png';

import Comp_Stu_Tab_Allotment from '../lms_component/comp_stu_tab_allotment';
import Comp_Stu_Tab_Activation from '../lms_component/comp_stu_tab_activation';

import Comp_Assign_Officers from '../lms_component/comp_assign_officers';

import Comp_Edit_Student_Basic from '../components/comp_edit_student_basic';
import Comp_Edit_Student_Family from '../components/comp_edit_student_family';
import Comp_Edit_Student_Auth from '../components/comp_edit_student_auth';



let loginUser="";
let userObject="";
let companyName="";
let clsStudentAdmission;

let rf="0";
window.Popper = Popper;

let genderList=["M.","F."];
let castCategoryList=["GEN","OBC","SC","ST"];
class View_Student_Officer_Mapping extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={stOfficers:[],stCadetDetails:{} ,stListClassFee:[],stListSessionYear:[],stListClassMaster:[],
        stListFeeCategory:[],stLsStudentBasic:[],stLsStudentFamily:[],stLsStudentAuth:[],stStudentId:"0"};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsStudentAdmission=this;
      }
//******  for child component function

updateTabSrNo(frmName){
  alert("Assign officer request under review");
  // btnSetColor_CBack(this,frmName,"tabAllotment",function(data,msg){
  //     if(data==="001"){
  //         alert("Updated Successfully");
  //         clsStudentAdmission.getStudentAdmission();
  //     }
  // })
}

updateTabActivation(frmName){
  btnSetColor_CBack(this,frmName,"tabAllotment",function(data,msg){
      if(data==="001"){
          alert(msg);
          clsStudentAdmission.getStudentAdmission();
      }
  })
}


editStudentFamily(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentFamily",function(data,msg){
    if(data==="001"){
        alert("Updated Successfully");
        clsStudentAdmission.getStudentAdmission();
    }
})
}
editStudentAuth(frmName){
  btnSetColor_CBack(this,frmName,"updateStudentAuth",function(data,msg){
    if(data==="001"){
        alert("Updated Successfully");
        clsStudentAdmission.getStudentAdmission();
    }
})
}

//**** end of child component function



      getStudentAdmission(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getStudentRecord"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        map.push({name:"ser_session_year",value:$("#ser_session_year").val()});
        map.push({name:"ser_academic_prog",value:$("#ser_academic_prog").val()});
        map.push({name:"ser_curriculum",value:$("#ser_curriculum").val()});
        map.push({name:"ser_stu_gender",value:$("#ser_stu_gender").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
       

        //alert($("#ser_session_year").val());
        //map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getStudentRecord";
        CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                $(".outstanding_rpt").html("Total :"+listData.length+" Records Found");
                
                clsStudentAdmission.setState({stListClassFee:listData},()=>{
                  //window.getPagination("#tbData");
                  clsStudentAdmission.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                });
              }
        });
      }
      okSucc(data,smg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful","Record Added Successfully",true);
          clsStudentAdmission.getClassMaster();
          $("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Not Working",smg,false);
        }
        // alert(data);
      }
stubasic_okSucc(data,msg){
  alert(data);

}

onUpdateTabAllotment(item,type_master){
    //alert(JSON.stringify(item));
    var map=[];
    map.push({name:"curl_type",value:"getSTO_CTO_Off"});
    map.push({name:"res_func",value:"callBackrrr"});
    map.push({name:"local_token",value:userObject[0].app_user_id});
    map.push({name:"user_type",value:userObject[0].type});
    map.push({name:"type_master_id",value:btoa(type_master)});
    
    
    
    map.push({name:"upper_id",value:userObject[0].upper_id});
    map["res_func"]="callBackrrr";
    map["curl_type"]="getSTO_CTO_Off";
    CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
      //alert(data);
        if(data!=="0" && data!==""){
            let listData=JSON.parse(data);
            var strData="";
            clsStudentAdmission.setState({stOfficers:listData},()=>{
              //window.getPagination("#tbData");
              clsStudentAdmission.forceUpdateHandler();
              //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
             
            
            });
          }
    });

    clsStudentAdmission.setState({stCadetDetails:item});
}

onStudentDetailsEdit(item){
  let map=[];
  map.push({name:"curl_type",value:"getMastStudentData"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  map.push({name:"user_type",value:userObject[0].type});
  map.push({name:"stu_id",value:btoa(item.id)});
  //alert($("#ser_session_year").val());
  //map.push({name:"upper_id",value:userObject[0].upper_id});
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMastStudentData";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    if(data!=="0"){
      let lsData=JSON.parse(data);
      clsStudentAdmission.setState({stLsStudentBasic:lsData.ls_stu_basic,
      stLsStudentFamily:lsData.ls_stu_family,stLsStudentAuth:lsData.ls_stu_auth,
      stStudentId:item.id},()=>{
        clsStudentAdmission.forceUpdateHandler();
      })
    }
  })

  
}

getMasters(){
  var map=[];
  map.push({name:"curl_type",value:"getMastersRequest"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:userObject[0].app_user_id});
  
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getMastersRequest";
  CallMapMethod_CBack(clsStudentAdmission,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
          let listData=JSON.parse(data);
          var strData="";
          //alert(JSON.stringify(listData.master_balance));
          clsStudentAdmission.setState({
            stListSessionYear:listData.ls_session_year,
            stListClassMaster:listData.ls_class_master,
          stListFeeCategory:listData.ls_fee_category},()=>{
            clsStudentAdmission.forceUpdateHandler();
          })
        }
  });
}
          
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getStudentAdmission();
this.getMasters();

$('#divTabAllotment').on('hidden.bs.modal', function () {
  clsStudentAdmission.setState({stCadetDetails:""});
});
$('#divEditStudentFamily').on('hidden.bs.modal', function () {
  window.location.reload();
});
$('#divEditStudentAuth').on('hidden.bs.modal', function () {
  window.location.reload();
});

}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">
{/* for now [row]it is unused */}
{/* starting of cols */}

<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">

         <CompGetAcademicYear userObject={userObject} comp_id="ser_session_year" comp_name="ser_session_year" placeHolder="Academic Year" propClass="form-control required" />
              
             </div>
         
         </div>
</div>

<div className='col-lg-2 col-md-2 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
          <CompGetAcademicProgram userObject={userObject} comp_id="ser_academic_prog" comp_name="ser_academic_prog" placeHolder="Academic Program" propClass="form-control" />
              
             </div>
         
         </div>
</div>

<div className='col-lg-1 col-md-1 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
         <CompGetCurriculum userObject={userObject} comp_id="ser_curriculum" comp_name="ser_curriculum" placeHolder="Curriculum" propClass="form-control required" />
             
             </div>
         
         </div>
</div>


<div className='col-lg-1 col-md-1 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <select id="ser_stu_gender" name="ser_stu_gender" className="form-control form-control-sm">
                <option value={"0"}>-Gender-</option>
                {genderList.map((item,index)=>{
                                                    return <option value={item}>{item}</option>
                                                  })}

               </select>
             </div>
         
         </div>
</div>


<div className='col-lg-4 col-md-4 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_text" name="ser_text" className="_setSearchKeyUp form-control form-control-sm" placeholder='search by Stu.Name,CDC,Enrollment' />
             </div>
         
         </div>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div onClick={()=>this.getStudentAdmission()}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>
                 <div  className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>
</div>
{/* end of cols */}

    </div>    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Student List</b></h3>
                <div className="outstanding_rpt float-left px-10"></div>
                <a className="btn btn-sm btn-danger float-right" href="../student_admission">Add New Student</a>
              </div>
                <table id="tbData" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>CDC No.</th>
                      <th>Student Name</th>
                      <th>Session Year</th>
                      <th>Acad. Program</th>
                      <th>STO</th>
                      <th>Master</th>
                      <th>CTO</th>
                      
                      {/* <th>e-Mail</th>
                      <th>Contact No</th>
                      
                      <th>Tab Sr. No.</th>
                      <th>Tab Fine Key</th> */}
                      <th>Tab Status</th>
                      <th>Admission Date</th>
                      <th>Admission</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.stListClassFee.map((item,index)=>{
                       return(<tr>
                        <td>{index+1}</td>
                        <td>{item.mem_no}</td>
                        <td>{item.full_name}</td>
                        <td>{item.session_name}</td>
                        <td>{item.academic_program}</td>  
                        <td>{item.sto}</td>  
                        <td>{item.master}</td>
                        <td>{item.cto}</td>
                        <td>{(item.tab_status==="Approved")?<span class="badge bg-success">{item.tab_status}</span>:<span class="badge bg-danger">{item.tab_status}</span>}</td>
                 <td>{item.commenced_date}</td>
                  <td>{item.status}</td>
                  <td>
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown"  data-toggle="dropdown" area-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                   
                     <a class="dropdown-item" onClick={()=>this.onUpdateTabAllotment(item,11)} data-toggle="modal" data-bs-toggle="modal" data-bs-target="#divAssignOfficer" data-target="#divAssignOfficer" href="javascript:void(0)">Assign STO</a>
                     <a class="dropdown-item" onClick={()=>this.onUpdateTabAllotment(item,14)} data-toggle="modal" data-bs-toggle="modal" data-bs-target="#divAssignOfficer" data-target="#divAssignOfficer" href="javascript:void(0)">Assign Master</a>
                     <a class="dropdown-item" onClick={()=>this.onUpdateTabAllotment(item,12)} data-toggle="modal" data-bs-toggle="modal" data-bs-target="#divAssignOfficer" data-target="#divAssignOfficer" href="javascript:void(0)">Assign CTO</a>
                     <a class="dropdown-item" onClick={()=>this.onStudentDetailsEdit(item)} data-toggle="modal" data-target="#divEditStudentAuth" href="javascript:void(0)">View Tab Log</a>
                    </div>
                  </div>
                  </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
                <div class='pagination-container' >
				<nav>
				  <ul class="pagination">
            
            <li data-page="prev" >
								     <span> {"<"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  
        <li data-page="next" id="prev">
								       <span> {">"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  </ul>
				</nav>
			</div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>
<Comp_Assign_Officers listOfficers={this.state.stOfficers} updateTabSrNo={this.updateTabSrNo} pCadetDetails={this.state.stCadetDetails} userOject={userObject} />
<Comp_Stu_Tab_Allotment updateTabSrNo={this.updateTabSrNo} pCadetDetails={this.state.stCadetDetails} userOject={userObject} />
<Comp_Stu_Tab_Activation updateTabActivation={this.updateTabActivation} pCadetDetails={this.state.stCadetDetails} userOject={userObject} />
    {/* <Comp_Edit_Student_Basic editStudentBasic={this.editStudentBasic} genderList={genderList} castCategoryList={castCategoryList} lsSessionYear={this.state.stListSessionYear} lsClassMaster={this.state.stListClassMaster} lsStudentBasic={this.state.stLsStudentBasic} app_user_id={userObject[0].app_user_id} />
    <Comp_Edit_Student_Family editStudentFamily={this.editStudentFamily} studentId={this.state.stStudentId}  lsStudentFamily={this.state.stLsStudentFamily}/>
    <Comp_Edit_Student_Auth editStudentAuth={this.editStudentAuth} lsClassMaster={this.state.stListClassMaster} studentId={this.state.stStudentId} lsStudentAuth={this.state.stLsStudentAuth}/>
     */}
          </div>)
      }
}
export default View_Student_Officer_Mapping;